import React, { useState, useEffect } from 'react';
import {
  Snackbar,
  Slide,
  IconButton,
  Box,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CloudOffIcon from '@mui/icons-material/CloudOff';

import useAlertContext from 'src/hooks/useAlertContext';

function SlideTransition(props) {
  return <Slide {...props} direction="up" />;
}

export default function NetworkDetector() {
  const [open, setOpen] = useState(false);
  const { alert } = useAlertContext();

  useEffect(() => {
    window.addEventListener('online', () => setOpen(false));
    window.addEventListener('offline', () => setOpen(true));
  });

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Snackbar
      open={open && !alert}
      onClose={handleClose}
      TransitionComponent={SlideTransition}
      ClickAwayListenerProps={{
        mouseEvent: false
      }}
      message={
        <>
          <Box display="flex" alignItems="center">
            <CloudOffIcon />
            <Typography variant="body2" style={{ marginLeft: '12px' }}>
              You are offline.
            </Typography>
          </Box>
        </>
      }
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={handleClose}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      }
    />
  );
}
